import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import {
  callTenantCreate,
  type TenantCreateInput,
  type TenantCreateResponse,
} from '../api/tenantCreate.js';

/**
 * S-06: `tenantCreate` Callable を呼ぶ React Query mutation hook。
 *
 * 成功時は `['tenants']` クエリを invalidate して TenantsListPage を即座に再取得させる。
 * （TenantsListPage は cache key `['tenants', 'all']` を使う）
 */
export function useTenantCreate(): UseMutationResult<
  TenantCreateResponse,
  Error,
  TenantCreateInput
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: TenantCreateInput) => callTenantCreate(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['tenants'] });
    },
  });
}
